import { useLang } from "@/lib/site";
import { copy } from "@/lib/content";
import { LogoMark } from "./Logo";

export const Marquee = () => {
  const { lang } = useLang();
  const words = copy[lang].marquee;
  const row = (
    <div className="flex shrink-0 items-center">
      {words.map((w, i) => (
        <span key={w} className="flex items-center">
          <span className={`font-display px-8 text-5xl sm:text-7xl whitespace-nowrap ${i % 2 ? "italic text-gold" : "text-outline"}`}>{w}</span>
          <LogoMark className="h-8 w-8 opacity-60" />
        </span>
      ))}
    </div>
  );
  return (
    <section data-testid="editorial-marquee" aria-hidden="true" className="relative overflow-hidden border-y border-amber-200/10 bg-[#0A0E19] py-8 select-none">
      <div className="marquee-track flex w-max">{row}{row}</div>
    </section>
  );
};
